import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const Delete = forwardRef<Ref, IconPropsType>(({ color = "currentColor", size, ...rest }, ref) => {
  return (
    <svg
      width={size ?? 20}
      height={size ?? 20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5013 0.833309C6.58083 0.833309 5.83464 1.5795 5.83464 2.49998V4.16664H2.5013C2.04107 4.16664 1.66797 4.53974 1.66797 4.99998C1.66797 5.46022 2.04107 5.83331 2.5013 5.83331H3.43268L4.07569 16.7645C4.12751 17.6454 4.85702 18.3333 5.73948 18.3333H14.2631C15.1456 18.3333 15.8751 17.6454 15.9269 16.7645L16.57 5.83331H17.5013C17.9616 5.83331 18.3346 5.46022 18.3346 4.99998C18.3346 4.53974 17.9616 4.16664 17.5013 4.16664H14.168V2.49998C14.168 1.5795 13.4218 0.833309 12.5013 0.833309H7.5013ZM12.5013 4.16664V2.49998H7.5013V4.16664H12.5013ZM8.1263 8.33331C8.58655 8.33331 8.95964 8.70642 8.95964 9.16667V13.3333C8.95964 13.7936 8.58655 14.1667 8.1263 14.1667C7.66607 14.1667 7.29297 13.7936 7.29297 13.3333V9.16667C7.29297 8.70642 7.66607 8.33331 8.1263 8.33331ZM12.7096 9.16667C12.7096 8.70642 12.3366 8.33331 11.8763 8.33331C11.4161 8.33331 11.043 8.70642 11.043 9.16667V13.3333C11.043 13.7936 11.4161 14.1667 11.8763 14.1667C12.3366 14.1667 12.7096 13.7936 12.7096 13.3333V9.16667Z"
        fill={color}
      />
    </svg>
  );
});
export default Delete;
